export default __webpack_public_path__ + "static/media/lamp9.0d778cd6.webp";